import React from "react"
import Image from "gatsby-image"
import { graphql, useStaticQuery } from "gatsby"
import Involved from "../Involved"

const query = graphql`
    {
        img1: file(relativePath: {eq: "1.jpg"}) {
            childImageSharp {
                fluid {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(relativePath: {eq: "2.jpg"}) {
            childImageSharp {
                fluid {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(relativePath: {eq: "3.jpg"}) {
            childImageSharp {
                fluid {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`

const Services = () => {
  const { img1, img2, img3 } = useStaticQuery(query)

  return (
    <section className="campaign-section bg-light" id="campaign">
      <div className="container">

        <div className="row align-items-center no-gutters mb-4 mb-lg-5">
          <div className="col-xl-8 col-lg-7">

            <Image fluid={img1.childImageSharp.fluid} className="img-fluid mb-3 mb-lg-0 box-shadow" alt="animal" />
            <small className="small text-black-50">Jewels in Nature</small>

          </div>
          <div className="col-xl-4 col-lg-5">
            <div className="featured-text text-center text-lg-left">
              <h4 className="mb-4 text-center">Aims and Objectives</h4>
              <div className="text-black-50 mb-0">
                <ul>
                  <li>Raise public awareness of the extent of damage caused to wildlife by construction projects
                  </li>
                  <li>Raise local and central government awareness of the extent of the problem</li>
                  <li>Investigate the extent of the problem and its impact on different categories of wildlife</li>
                  <li>To look at existing constructions such as motorways and railways to determine whether
                    retrospective solutions could be introduced
                  </li>
                  <li>
                    To develop a regional network of wildlife groups, raising the profile of this issue with the
                    objective of influencing developers and planners to look for solutions to their impact on
                    wildlife
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center no-gutters mb-5 mb-lg-0">
          <div className="col-lg-6 my-auto">
            <Image fluid={img2.childImageSharp.fluid} className="img-fluid" alt="animal" />
          </div>
          <div className="col-lg-6">
            <div className="bg-green text-center h-100 project">
              <div className="d-flex h-100">
                <div className="campaign-text w-100 my-auto text-center text-lg-left">
                  <h4 className="text-white mb-3">How can you help?</h4>
                  <div className="mb-0 text-white-50">
                    <ul>
                      <li>Contact us on safepassageforwildlife@zohomail.com.</li>
                      <li>Start a Safe Passage For Wildlife Campaign group in your area.</li>
                      <li>Write to your MP and local Councillors. We can
                        provide a template letter if it will help.
                      </li>
                      <li>Share information about our campaign.
                      </li>
                      <li>Do you have any fundraising suggestions to support the campaign?</li>
                    </ul>
                  </div>
                  <hr className="d-none d-lg-block mb-0 ml-0" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center no-gutters">
          <div className="col-lg-6 my-auto">
            <Image fluid={img3.childImageSharp.fluid} className="img-fluid" alt="animal" />
            <small className="small text-black-50 text-right float-right">Scott Bailey</small>

          </div>
          <div className="col-lg-6 order-lg-first">
            <div className="bg-green text-center h-100 project">
              <div className="d-flex h-100">
                <div className="campaign-text w-100 my-auto text-center text-lg-left">
                  <h4 className="text-white">Get involved</h4>
                  <p className="mb-0 text-white-50">
                    <ul>
                      <li>Help us build a picture of the extent of animal road
                        collisions in your
                        area.
                      </li>
                      <li>Report regular accidents to us involving Wildlife – an image is helpful.</li>
                      <li>Contact your local council to report animals left dead in the road or by the road side.</li>
                      <li>For Badgers injured or dead please also contact <a className="text-white"
                                                                             href="https://www.badgertrust.org.uk/gbab">Badger
                        Trust</a></li>
                      <li>You can help by slowing down on roads known to be of concern to the local wildlife.
                      </li>
                      <li>Animals have families too, many mothers are killed on the road leaving their young behind so
                        reporting is vital for their wellbeing.
                      </li>
                    </ul>
                  </p>
                  <hr className="d-none d-lg-block mb-0 mr-0" />
                </div>
              </div>

            </div>


          </div>
        </div>
      </div>
      <div className="container mx-auto flex text-center p-5 justify-content-center align-items-center">

        <a
          href="mailto:safepassageforwildlife@zohomail.com?subject=Accident Report"> <span
          className="text-white"><button className="btn btn-primary mx-auto "
                                         type="submit">Click here to report an accident</button></span></a>
      </div>
      <Involved />
    </section>
  )
}

export default Services
